// https://github.com/reduxjs/redux/blob/e7097be3edcc2ba76cbb6d3aea77e63be2d7e80c/docs/recipes/structuring-reducers/RefactoringReducersExample.md
import createNextState from 'immer'

export default (initialState, handlers) => (state = initialState, action) =>
  createNextState(state, (draft) => {
    const reducer = handlers[action.type]
    return reducer ? reducer(draft, action) : undefined
  })
